const doc = [({"da":({"js":({"admin":({"comments":({"expanded_content_partial":({"comment_log":"Kommentarlog", "write_comment":"Skriv kommentar"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;